import React from 'react';

export default function PageDivider({ className = '' }) {
  return <div className={['wt-page-divider', className].filter(Boolean).join(' ')} aria-hidden="true" />;
}
